import { Controller } from 'react-hook-form';
import { StyleSheet } from 'react-native-unistyles';
import TextInput from '@/components/Unistyles/TextInput';

function EventEditInputNote() {
  return (
    <Controller
      name="notes"
      render={({ field }) => (
        <TextInput
          onChangeText={field.onChange}
          value={field.value}
          multiline
          placeholder="Notes, optional"
          style={styles.notesInput}
          testID="EventEditInputNote"
        />
      )}
    />
  );
}
export default EventEditInputNote;
const styles = StyleSheet.create((theme) => ({
  notesInput: {
    height: theme.size(25),
    textAlignVertical: 'top',
  },
}));
